export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    active: 1,
    state: '',
    offerPartners: {
      partner: {
        id: {
          value: '',
          operator: 'in',
        },
      },
      tags: {
        id: {
          value: '',
          operator: 'in',
        },
      },
    },
    advertiser: {
      id: {
        value: '',
        operator: 'in',
      },
    },
    country: {
      country: {
        id: {
          value: '',
          operator: 'in',
        },
      },
    },
    paymentModel: {
      id: {
        value: '',
        operator: 'in',
      },
    },
    product: {
      id: {
        value: '',
        operator: 'in',
      },
    },
    partnersGroups: {
      id: {
        value: '',
        operator: 'in',
      },
    },
  },
  sortBy: ['id'],
  sortDesc: [true],
  clientOptions: {
    filterPanelExpanded: false,
  },
})
